import { useEffect, useState } from 'react'
import { CombinedGame, Game, GameEvent, GameLineup, GamePresstext } from 'types'
import {
  getCombinedGame,
  getGame,
  getGameEvents,
  getGameLineup,
  getGamePresstext
} from 'api/game'

type UseGameData = {
  game: Game | null
  lineup: GameLineup | null
  events: GameEvent[] | null
}

// uncomment to disable refresh (loading data from staging, which is not always desired)
const doRefresh = true

// Refetch Game Data every 5seconds
export const useGameData = (id: string | string[] | undefined): UseGameData => {
  const [game, setGame] = useState<Game | null>(null)
  const [lineup, setLineup] = useState<GameLineup | null>(null)
  const [events, setEvents] = useState<GameEvent[] | null>(null)

  if (doRefresh) {
    useEffect(() => {
      let timeout: any
      if (id) {
        timeout = setInterval(() => {
          getGame(id.toString()).then((d) => setGame(d.data))
          getGameLineup(id.toString()).then((d) => setLineup(d.data))
          getGameEvents(id.toString()).then((d) => setEvents(d.data))
        }, 5000)
      }
      return () => clearInterval(timeout)
    }, [id])
  }

  return {
    game,
    lineup,
    events
  }
}

export const useCombinedGameData = (
  id: string | string[] | undefined
): UseGameData => {
  const [data, setData] = useState<CombinedGame | null>(null)

  if (doRefresh) {
    useEffect(() => {
      let timeout: any
      if (id) {
        getCombinedGame(id.toString()).then((d) => {
          setData(d.data)
        })
        timeout = setInterval(() => {
          getCombinedGame(id.toString()).then((d) => {
            setData(d.data)
          })
        }, 5000)
      }
      return () => clearInterval(timeout)
    }, [id])
  }

  return {
    game: data ? data.summary : null,
    lineup: data ? data.lineup : null,
    events: data ? data.events : null
  }
}

type UseGamePresstextData = {
  isLoading: boolean
  presstext: string | null
  updatedAt: number | null
}

export const useGamePresstextData = (
  id: string | string[] | undefined
): UseGamePresstextData => {
  const [data, setData] = useState<GamePresstext | null>(null)
  const [isLoading, setLoading] = useState<boolean>(true)

  // no refresh interval needed here
  useEffect(() => {
    if (id) {
      setLoading(true)
      getGamePresstext(id.toString()).then((d) => {
        setData(d.data)
        setLoading(false)
      })
    }
  }, [id])

  return {
    isLoading,
    presstext: data ? data.presstext : null,
    updatedAt: data ? data.updatedAt : null
  }
}
